import { useContext } from 'react';

import { media } from 'context';
import { IconButton, Layout, SwiperCarousel } from 'ds';
import { SwiperSlide } from 'swiper/react';

import OfficeExperienceCard from './OfficeExperienceCard';

interface OfficeExperienceCardsSwiperProps {
  onCardClick: (index: number) => void;
}

const OfficeExperienceCardsSwiper = ({ onCardClick }: OfficeExperienceCardsSwiperProps) => {
  const { sm, isMobile, xxs } = useContext(media);
  const OFFERINGS = [
    {
      title: 'AI office assistant',
      srcKey: 'da2163cf11a26310e5eb89f6539cd829_RKNSpCNBb.png'
    },
    {
      title: 'Furniture & design',
      srcKey: 'Image_8K4C0ljIk.png?updatedAt=1744070603687'
    },
    {
      title: 'Internet & IT',
      srcKey: 'Image__QqLV_xBq.png?updatedAt=1744071034444'
    },
    {
      title: 'Supply restocking',
      srcKey: 'Frame%201000002291_hqqv_gXoA.png'
    },
    {
      title: 'Cleanings',
      srcKey: 'Frame%201000002291_6QHavEsU6.png?updatedAt=1744073092714'
    },
    {
      title: 'Vendor network with exclusive discounts',
      srcKey: 'phone_booth_rOSLr0BuX.png?updatedAt=1744073179568'
    }
  ];

  return (
    <Layout width="100%" maxWidth={sm ? 341 : 704} style={{ overflow: 'hidden', overflowX: 'hidden' }}>
      <SwiperCarousel
        pagination={false}
        width={sm ? 341 : undefined}
        style={{ overflow: 'hidden', overflowX: 'hidden' }}
        allowTouchMove={isMobile ? true : false}
        controlLayoutProps={{
          left: -12,
          right: -12
        }}
        config={{
          md: {
            slidesPerView: 3,
            spaceBetween: 16
          },
          sm: {
            slidesPerView: 1.4,
            spaceBetween: 10
          },
          phone: {
            slidesPerView: xxs ? 1.3 : 1.5,
            spaceBetween: 16
          }
        }}
        leftArrow={
          <IconButton name={'leftChevron'} size={'lg'} iconSize={'sm'} stroke={2} iconColor="blue-500" type={'white'} />
        }
        rightArrow={
          <IconButton
            name={'rightChevron'}
            size={'lg'}
            iconSize={'sm'}
            stroke={2}
            iconColor="blue-500"
            type={'white'}
          />
        }
      >
        {OFFERINGS.map((offering, index) => (
          <SwiperSlide key={offering.title}>
            <OfficeExperienceCard
              srcKey={offering.srcKey}
              title={offering.title}
              onClick={() => {
                onCardClick(index);
              }}
            />
          </SwiperSlide>
        ))}
      </SwiperCarousel>
    </Layout>
  );
};

export default OfficeExperienceCardsSwiper;
